import * as apiDelete from 'api/identityProvider/DeleteIdentityProviderIdV1';
import * as apiRestore from 'api/identityProvider/PostIdentityProviderRestoreV1';
import * as apiPostSearch from 'api/identityProvider/PostIdentityProviderSearchV1';

export default class IdentityProvider {
	public id: string = '';
	public name: string = '';
	public iconSvgUrl: string = '';
	public sortOrder: number = 0;

	public constructor(input?: apiPostSearch.ResponseIdentityProvider) {
		if (input) {
			this.mapFromApi(input);
		}
	}

	public async callApiDelete(): Promise<void> {
		await apiDelete.callApi(this.id);
	}

	public async callApiRestore(): Promise<void> {
		await apiRestore.callApi(this.id);
	}

	private mapFromApi(input: apiPostSearch.ResponseIdentityProvider) {
		this.id = input.id;
		this.name = input.name;
		this.iconSvgUrl = input.iconSvgUrl;
		this.sortOrder = input.sortOrder;
	}
}
